import {GroupBase, StylesConfig} from "react-select";

export type Option = { value: string; label: string };

export const selectShadcnStyles: StylesConfig<Option, boolean, GroupBase<Option>> = {
    control: (base, state) => ({
        ...base,
        backgroundColor: "var(--input-bg, white)",
        borderColor: "#e5e5e5",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(0,0,0,0.1)" : "none",
        "&:hover": {
            borderColor: "#e5e5e5",
        },
        minHeight: "36px",
        height: "36px",
        outline: "none",
    }),
};